function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

const loopRequestResult = <D, T>(
  // 请求函数
  request: (params: D) => Promise<T>,
  requestParams: D,
  // 超时，毫秒
  timeout: number,
  // 请求的间隔时间，毫秒
  timeStep: number,
  // 通过条件
  pass: (res: T) => boolean,
  requestGoOn?: () => boolean,
) => {
  let isStop = false;
  let startAt: number;

  const getResult = async () => {
    isStop = false;

    let now = new Date().getTime();
    while (now - startAt < timeout) {
      if (requestGoOn) isStop = !requestGoOn();
      if (isStop) return Promise.reject("request has been stop");

      now = new Date().getTime();
      const res = await request(requestParams);
      if (pass(res)) {
        isStop = true;
        return res;
      }
      await sleep(timeStep);
    }

    throw new Error("request has been timeout");
  };

  return {
    start: () => {
      startAt = new Date().getTime();
      return getResult();
    },
    stop: () => {
      isStop = true;
    },
  };
};

export default loopRequestResult;

interface PollingOpt {
  interval: number;
  exponentialRetreat: boolean;
}

export function polling(
  fetcher: () => Promise<any>,
  checker: (res: any) => 1 | 0 | -1 | -2,
  opt: PollingOpt = {
    interval: 2000,
    exponentialRetreat: false,
  },
): Promise<any> {
  return new Promise((resolve, reject) => {
    let count = 1;
    const executer = async () => {
      const res = await fetcher();
      switch (checker(res)) {
        case 1:
          resolve(res);
          break;
        case 0:
          setTimeout(executer, opt.exponentialRetreat ? count * opt.interval : opt.interval);
          break;
        case -1:
          reject(res);
          break;
        case -2:
          reject("CANCELLED");
          break;
      }
      count++;
    };
    setTimeout(executer, opt.interval);
  });
}
